var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cotton-device-monitor"},[_c('InspectionCard',{attrs:{"data":_vm.cd602DeviceList}}),_c('DetectionCard',{attrs:{"deviceList":_vm.cd603DeviceList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }